/**
 * The organization's brand tier as `RuntimeBrandProvider` resolved it
 * (ORDR-139). Its own module so the provider file exports only a component.
 */

import { createContext, useContext } from "react";
import type { BrandTier } from "@pirouz-ca/ui-tokens";

export const OrganizationBrandContext = createContext<BrandTier | null>(null);

/** The organization's brand tier, or `null` while loading, when unbranded, and on any failure. */
export function useOrganizationBrand(): BrandTier | null {
  return useContext(OrganizationBrandContext);
}
